<template>
  <div>
    <layout-loading v-if="isSubmit" />
    <changeLanguageHeaderTable
      :current-language="currentLanguage"
      @change-language="changeLanguage"
    />
    <BDataTable
      ref="refTable"
      :fetch-list="fetchList"
      :table-columns="tableColumns"
      :filters="filters"
      @onGroupDelete="groupDelete"
    >
      <!-- Column: status -->
      <template #cell(status)="{ item }">
        <pill-icon-cell
          :status="$t(`articles.${item.status}`)"
          :width="110"
        />
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="{ item }">
        <edit-row @click.native="toEditPage(item._id)" />
        <delete-row @click.native="deleteItem(item._id)" />
      </template>
    </BDataTable>
  </div>
</template>

<script>
import BDataTable from '@/components/BDataTable/index.vue'
import '@/components/BMediaCustom/index.vue'
import DeleteRow from '@/components/BDataTable/Actions/DeleteRow.vue'
import EditRow from '@/components/BDataTable/Actions/EditRow.vue'
import LayoutLoading from '@/components/LayoutLoading.vue'
import PillIconCell from '@/components/BDataTable/Elements/PillIconCell.vue'
import changeLanguageHeaderTable from '@/components/change-language-header-table.vue'
import useVideosList from './useVideosList'

export default {
  name: 'VideosList',
  components: {
    BDataTable,
    DeleteRow,
    EditRow,
    LayoutLoading,
    PillIconCell,
    changeLanguageHeaderTable,
  },
  setup() {
    const {
      changeLanguage,
      currentLanguage,
      deleteItem,
      fetchList,
      groupDelete,
      isSubmit,
      refTable,
      statusOptions,
      tableColumns,
      toEditPage,
    } = useVideosList()
    return {
      changeLanguage,
      currentLanguage,
      deleteItem,
      fetchList,
      groupDelete,
      isSubmit,
      refTable,
      statusOptions,
      tableColumns,
      toEditPage,
    }
  },
  computed: {
    filters() {
      return {
        type: 'video',
      }
    },
  },
}
</script>
